import { defineStore } from "pinia";

export const useBusinessStore = defineStore("business", {
    state: () => ({
        handle: "",
        companyData: null,
        isDraksy: false,
        // Meta CAPI correlation id, injected by the SSR server per request and passed
        // to the app as ?dtk= on the signup link. Null on customer sites.
        trackingId: null,
    }),
    actions: {
        setHandle(handle) {
            this.handle = handle;
        },
        setCompanyData(data) {
            this.companyData = data;
        },
        setIsDraksy(isDraksy) {
            this.isDraksy = isDraksy;
        },
        setTrackingId(trackingId) {
            this.trackingId = trackingId;
        }
    }
});
